import { render, staticRenderFns } from "./BaseOTPInput.vue?vue&type=template&id=6fc8a174&scoped=true&"
import script from "./BaseOTPInput.vue?vue&type=script&lang=js&"
export * from "./BaseOTPInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseOTPInput.vue?vue&type=style&index=0&id=6fc8a174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc8a174",
  null
  
)

export default component.exports